// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { ScalarDecode, ScalarDecodeT } from "./scalar-decode";
import { StructDecode, StructDecodeT } from "./struct-decode";
import { TextDecode, TextDecodeT } from "./text-decode";
import { TransformDecode, TransformDecodeT } from "./transform-decode";

export enum Decode {
  NONE = 0,
  ScalarDecode = 1,
  StructDecode = 2,
  TextDecode = 3,
  TransformDecode = 4,
}

export function unionToDecode(
  type: Decode,
  accessor: (
    obj: ScalarDecode | StructDecode | TextDecode | TransformDecode,
  ) => ScalarDecode | StructDecode | TextDecode | TransformDecode | null,
): ScalarDecode | StructDecode | TextDecode | TransformDecode | null {
  switch (Decode[type]) {
    case "NONE":
      return null;
    case "ScalarDecode":
      return accessor(new ScalarDecode())! as ScalarDecode;
    case "StructDecode":
      return accessor(new StructDecode())! as StructDecode;
    case "TextDecode":
      return accessor(new TextDecode())! as TextDecode;
    case "TransformDecode":
      return accessor(new TransformDecode())! as TransformDecode;
    default:
      return null;
  }
}

export function unionListToDecode(
  type: Decode,
  accessor: (
    index: number,
    obj: ScalarDecode | StructDecode | TextDecode | TransformDecode,
  ) => ScalarDecode | StructDecode | TextDecode | TransformDecode | null,
  index: number,
): ScalarDecode | StructDecode | TextDecode | TransformDecode | null {
  switch (Decode[type]) {
    case "NONE":
      return null;
    case "ScalarDecode":
      return accessor(index, new ScalarDecode())! as ScalarDecode;
    case "StructDecode":
      return accessor(index, new StructDecode())! as StructDecode;
    case "TextDecode":
      return accessor(index, new TextDecode())! as TextDecode;
    case "TransformDecode":
      return accessor(index, new TransformDecode())! as TransformDecode;
    default:
      return null;
  }
}

export type DecodeT =
  | { type: "NONE"; value: null }
  | { type: "ScalarDecode"; value: ScalarDecodeT }
  | { type: "StructDecode"; value: StructDecodeT }
  | { type: "TextDecode"; value: TextDecodeT }
  | { type: "TransformDecode"; value: TransformDecodeT };
